import React from "react";
import { motion } from "framer-motion";

// Restrained network-node indicator consistent with the Rendeavored mark.
export const NodeLoader = ({ size = 26, reduced = false }) => {
  const nodes = [
    { cx: 7, cy: 7 }, { cx: 21, cy: 9 }, { cx: 13, cy: 20 },
  ];
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <g stroke="#1E6BFF" strokeWidth="1.5" opacity="0.5">
        <line x1="7" y1="7" x2="21" y2="9" />
        <line x1="21" y1="9" x2="13" y2="20" />
        <line x1="7" y1="7" x2="13" y2="20" />
      </g>
      {nodes.map((n, i) => (
        <motion.circle
          key={i}
          cx={n.cx}
          cy={n.cy}
          r="3.2"
          fill={i === 2 ? "#1E6BFF" : "#FFFFFF"}
          initial={{ opacity: 0.35 }}
          animate={reduced ? { opacity: 0.9 } : { opacity: [0.35, 1, 0.35] }}
          transition={reduced ? {} : { duration: 1.4, repeat: Infinity, delay: i * 0.25 }}
        />
      ))}
    </svg>
  );
};

export default NodeLoader;
